exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.casestudies-section[data-v-4fce09d8] {\n  position: relative;\n}\n.case-study-article-container[data-v-4fce09d8] {\n  width: 95%;\n  margin: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4fce09d8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/LP/CaseStudies.vue
// module id = as00
// module chunks = 0